
import React, { useContext } from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import OutdoorGrillIcon from '@mui/icons-material/OutdoorGrill';
import SpeedIcon from '@mui/icons-material/Speed';
import ThreeSixtyIcon from '@mui/icons-material/ThreeSixty';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Divider } from '@mui/material';
import config from '../../config';
import AuthContext from '../../services/Auth/AuthContext';


export function MainListItems() {
  const { t } = useTranslation('common');
  const authService = useContext(AuthContext);
  return (
    <div>
      <Link to="/events">
        <ListItem button>

          <ListItemIcon>
            <SpeedIcon />
          </ListItemIcon>

          <ListItemText primary={t("mainList.events")} />

        </ListItem>
      </Link>
      <Link to="/circuits">
        <ListItem button>
          <ListItemIcon>
            <ThreeSixtyIcon />
          </ListItemIcon>
          <ListItemText primary={t("mainList.circuits")} />
        </ListItem>
      </Link>
      <Link to="/organizers">
        <ListItem button>
          <ListItemIcon>
            <OutdoorGrillIcon />
          </ListItemIcon>
          <ListItemText primary={t("mainList.organizers")} />
        </ListItem>
      </Link>

      {authService?.isInRole(config.managementGroups.organizer, config.managementGroups.administrator) === true &&
        <React.Fragment>
          <Divider />
          <Link to="/events/organizer">
            <ListItem button>
              <ListItemIcon>
                <DeveloperBoardIcon />
              </ListItemIcon>
              <ListItemText primary={t("organizer.manageEvents")} />
            </ListItem>
          </Link>
        </React.Fragment>}
    </div>
  );
}



